<template>
  <div class="BlogsPage">
      <div v-if="isLoading">
        <PreLoad />
      </div>
      <div v-else class="container mb-3">
        <div class="row text-right" dir="rtl">
          <h1 class="my-3">مطالب نورا</h1>
          <StorySlider :stories="response.stories"/>
          <div class="filters py-3">
            <p @click="addFilter('sort', '-view')" class="sort-btn mx-2 pointer" :class="activeFilters[0][1] === '-view' ? 'active' : ''"> پربازدید </p>
            <p @click="addFilter('sort', '-pk')" class="sort-btn mx-2 pointer" :class="activeFilters[0][1] === '-pk' ? 'active' : ''"> جدیدترین </p>
            <p @click="addFilter('sort', '-news')" class="sort-btn mx-2 pointer" :class="activeFilters[0][1] === '-news' ? 'active' : ''"> خبری </p>
            <p @click="addFilter('sort', '-learns')" class="sort-btn mx-2 pointer" :class="activeFilters[0][1] === '-learns' ? 'active' : ''"> آموزشی </p>
          </div>
        </div>
        <div class="row"  dir="rtl">
          <div class="col-lg-9 col-md-9 col-sm-12 col-12" v-if="blogs.length !== 0 ">
            <div class="row">
              <template :key="(blog,index)" v-for="(blog,index) in blogs">
                <transition name="fade" mode="out-in">
                  <BlogCard :carousel="false" :obj="blog" v-if="index < paginator" />
                </transition>
              </template>
            </div>
            <div class="load-more">
              <button aria-label="دیدن مطالب بیشتر" v-if="paginator < blogs.length" class="btn btn-secondary my-4" @click="paginator += 6">بیشتر</button>
            </div>
          </div>
          <div class="col-lg-9 col-md-9 col-sm-12 col-12" v-if="blogs.length === 0 ">
            <div class="row">
              <template :key="(blog,index)" v-for="(blog,index) in 6">
                <transition name="fade" mode="out-in">
                  <BlogCard :carousel="false" :obj="null" />
                </transition>
              </template>
            </div>
          </div>
          <div class="col-lg-3 col-md-3 col-sm-12 col-12">
            <div class="filters mt-3">
              <div class="search-form my-4" dir="rtl">
                  <input class="form-control br25" type="text" v-model="q" placeholder="جستجو ... ">
                  <button aria-label="جستجو" class="btn btn-secondary p-2 w25px" @click="$router.push('/search-blog?q=' + q)"><i class="fa fa-search" aria-hidden="true"></i></button>
              </div>
              <h3 class="filter-title mt-4">جدیدترین مطالب</h3>
              <hr>
              <div class="blogs-list">
                <div class="d-flex my-2" :obj="blog" :key="blog" v-for="blog in blogsNew">
                  <router-link :to="'/blog/'+ this.$blogCategories.filter(item => item.id === blog.category)[0].slug + '/' + blog.slug ">
                    <img class="blog-sidebar-image" :alt="blog.name" v-lazy="$MEDIA + blog.image" />
                  </router-link>
                  <router-link :to="'/blog/'+ this.$blogCategories.filter(item => item.id === blog.category)[0].slug + '/' + blog.slug ">
                    <p class="m-2">{{strLimit(blog.name,55)}}</p>
                  </router-link>
                </div>
              </div>
              <h3 class="filter-title mt-4">پربازدید مطالب</h3>
              <hr>
              <div class="blogs-list mb-4">
                <div class="d-flex my-2" :obj="blog" :key="blog" v-for="blog in blogsView">
                  <router-link :to="'/blog/'+ this.$blogCategories.filter(item => item.id === blog.category)[0].slug + '/' + blog.slug ">
                    <img class="blog-sidebar-image" :alt="blog.name" v-lazy="$MEDIA + blog.image" />
                  </router-link>
                  <router-link :to="'/blog/'+ this.$blogCategories.filter(item => item.id === blog.category)[0].slug + '/' + blog.slug ">
                    <p class="m-2">{{strLimit(blog.name,55)}}</p>
                  </router-link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
  </div>
</template>
<script>
import BlogCard from '@/components/BlogCard.vue'
import StorySlider from '@/components/StorySlider.vue'
import PreLoad from '@/components/PreLoad.vue'

export default {
  name: 'BlogsPage',
  components: {
    BlogCard,
    StorySlider,
    PreLoad
  },
  data () {
    return {
      response: {},
      blogs: [],
      blogsNew: [],
      blogsView: [],
      paginator: 6,
      activeFilters: [['', '']],
      q: '',
      isLoading: true
    }
  },
  methods: {
    pageLoad: function () {
      this.isLoading = true
      this.activeFilters = this.parseExtra(this.$route.fullPath.replace('/blogs', ''))
      if (!this.$route.query.sort) {
        this.$route.query.sort = '-pk'
      }
      const query = `{
      blogsNew:getBlogs(filters:{
        count:5,
        order: "-pk",
      }){
        id,
        category,
        image,
        name,
        slug,
      },
      blogsView:getBlogs(filters:{
        count:5,
        order: "-view",
      }){
        id,
        category,
        image,
        name,
        slug,
      },
      blogs:getBlogs(filters:{
        order: "${this.$route.query.sort}",
      }){
        id,
        category,
        image,
        name,
        slug,
        rates,
        description,
      }
      meta(key:"${this.$options.name}") {
        seoTitle
        seoKeyword
        seoDescription
      }
      stories (key: "BlogsPage") {
        id
        videoCover
        link
        video
        prev
        next
      }
    }
      `

      this.$fetchGraphQL(query)
        .then((response) => {
          this.response = response.data
          this.setMetaByObj(response.data.meta)
          this.blogsNew = response.data.blogsNew
          this.blogsView = response.data.blogsView
          this.blogs = response.data.blogs
          this.isLoading = false
        })
        .catch((error) => {
          console.log(error)
          this.isLoading = false
        })
    }
  },
  mounted () {
    this.pageLoad()
  },
  watch: {
    '$route.query.sort' (to, from) {
      this.pageLoad()
    }
  }
}
</script>

<style scoped>
.active{
  border: solid #f08c85 2px !important;
  background-color: #f08c85;
  color:black;
}
.blog-sidebar-image{
  height: 50px;
  width: auto;
  border-radius: 10%;
}
.filters{
  background: #f2f2f2;
  padding: 8px 15px;
  border-radius: 3px;
  clip-path: polygon(25px 0%, 100% 0%, 100% 50%, 100% 100%, 0% 100%, 0% 25px);
}
.fa-solid{
  color: #707071;
}
.filter-title{
  font-size: 13pt;
}
.load-more{
  display: flex;
  justify-content: center;
}
button{
  width: fit-content;
  padding: 7px 95px;
}
.btn-check:active+.btn-secondary, .btn-check:checked+.btn-secondary, .btn-secondary.active, .btn-secondary:active, .show>.btn-secondary.dropdown-toggle {
  color: #000;
  background-color: #86e9fc;
  border-color: #86e9fc;
}
.btn-secondary:hover {
  color: #000;
  background-color: #86e9fc;
  border-color: #86e9fc;
}
.btn-check:focus+.btn-secondary, .btn-secondary:focus {
  color: #000;
  background-color: #86e9fc;
  border-color: #86e9fc;
  box-shadow: none;
}
.br25{
  border-radius: 24px !important;
}
.w25px{
  width: 47px !important;
}
.sort-btn{
  border: solid #f08c85 2px;
  color: black;
  padding: 6px 10px;
  border-radius: 24px;
  width: max-content;
  transition: 0.4s;
  display: inline-block;
  margin: 5px;
}
.sort-btn:not(.active):hover {
  background-color: #f08c85;
  color: black;
  padding: 6px 13px;
  border-radius: 24px;
  width: max-content;
}
</style>
